module.exports = __webpack_public_path__ + "static/media/overlay9.977796c5.png";